import { useAppSelector } from '@/store/hooks';

import { useRestoreSession } from '../hooks';
import { SessionLoadError } from './SessionLoadError';
import { selectUser } from '../store/authSlice';

export function SessionRestoreGate({ children }: { children: React.ReactNode }) {
  const { isRestoring, isError, retry } = useRestoreSession();
  const user = useAppSelector(selectUser);

  if (isRestoring) return null;
  // Only a stored user has a session worth retrying; signing out from here clears it and lets the app render.
  if (isError && user !== null) return <SessionLoadError onRetry={retry} />;
  return children;
}
